import { createContext } from 'react'

export const ServerContext = createContext<null | {
  defaultBreakpoint: number
}>(null)
